<template>
  <div class="sourceMaterial">
    <h3 class="sourceMaterial_title">素材库</h3>
    <el-tabs v-model="activeName">
      <el-tab-pane label="图库" name="first"><ImgComp v-if="activeName === 'first'" /> <div v-else /></el-tab-pane>
      <!-- <el-tab-pane label="图库查看次数配置" name="second"><photoLookCount v-if="activeName === 'second'" /><div v-else /></el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script>
import ImgComp from './components/imgComp.vue'
export default {
  components: {
    ImgComp
  },
  data() {
    return {
      activeName: 'first'
    }
  }
}
</script>

<style lang="less" scoped>
.sourceMaterial{
  margin: 0 auto;
  margin-top: 30px;
  width: 90%;
}
</style>
